
import { useNavigate } from '@/composable';
import { defineComponent, PropType } from 'vue';
import ButtonItem from '../Button/index.vue';
import TitleAndDescription from '../TitleAndDescription/index.vue';

export interface IItemImg {
  linkImage: string;
  title?: string;
  description?: string;
  titleButton?: string;
  iconRsc?: string;
  isShowLineButtom?: boolean;
  url?: string;
}

export default defineComponent({
  name: 'ImageItem',
  components: {
    ButtonItem,
    TitleAndDescription
  },
  props: {
    itemImg: {
      type: Object as PropType<IItemImg>,
      default: () => ({})
    },
    isShowLineButtom: Boolean
  },
  setup(props) {
    const { navigate } = useNavigate();

    const onClick = () => {
      if (props.itemImg?.url) {
        navigate('/shop', 'router', { id: props.itemImg.url });
        // navigate(`/shop?id=${props.itemImg.url}`);
      }
    };
    return {
      onClick
    };
  }
});
